export default "__VITE_ASSET__CYygvdzi__"